import { useEffect, useState } from 'react';
import FontPicker from 'font-picker-react';
import { RadioGroup, Radio, Stack } from '@workramp/ui';
import { CUSTOM_FONT, CUSTOM_GOOGLE_FONT_FAMILY, DEFAULT_FONT, DEFAULT_GOOGLE_FONT } from '../constants';
import FontUpload from './FontUpload';

const NUMBER_OF_GOOGLE_FONTS_TO_LOAD = 200;

interface FontPickerProps {
  label: string;
  googleFontsApiKey: string;
  customGoogleFontFamily: string;
  customFontFile: string;
  updateFontOptions: (googleFontValue: string, customFontValue: string) => void;
  academyId: number;
  customFont: string;
}

export function WrFontPicker({
  label,
  googleFontsApiKey,
  updateFontOptions,
  customGoogleFontFamily,
  academyId,
  customFontFile,
  customFont,
}: FontPickerProps) {
  const [currentFont, setCurrentFont] = useState(DEFAULT_FONT);

  useEffect(() => {
    if (customGoogleFontFamily) {
      setCurrentFont(CUSTOM_GOOGLE_FONT_FAMILY);
    }

    if (customFont) {
      setCurrentFont(CUSTOM_FONT);
    }
  }, [customFont, customGoogleFontFamily]);

  const uploadCompletedCallback = () => {
    updateFontOptions(customGoogleFontFamily || '', 'true');
  };

  const onCustomFileDeleted = () => {
    if (customGoogleFontFamily) {
      updateFontOptions(customGoogleFontFamily, '');
      setCurrentFont(CUSTOM_GOOGLE_FONT_FAMILY);
    } else {
      updateFontOptions('', '');
      setCurrentFont(DEFAULT_FONT);
    }
  };

  const handleFontSelected = (val) => {
    if (val === DEFAULT_FONT) {
      updateFontOptions('', '');
      setCurrentFont(DEFAULT_FONT);
    }
    if (val === CUSTOM_GOOGLE_FONT_FAMILY) {
      updateFontOptions(customGoogleFontFamily || '', '');
      setCurrentFont(CUSTOM_GOOGLE_FONT_FAMILY);
    }
    if (val === CUSTOM_FONT) {
      updateFontOptions(customGoogleFontFamily || '', 'true');
      setCurrentFont(CUSTOM_FONT);
    }
  };

  return (
    <Stack size={2}>
      <RadioGroup label={label} value={currentFont} onChange={(val) => handleFontSelected(val)}>
        <Radio value={DEFAULT_FONT}>Default Font</Radio>
        <Radio value={CUSTOM_GOOGLE_FONT_FAMILY}>Google Web Font</Radio>
        <Radio value={CUSTOM_FONT}>Custom Font</Radio>
      </RadioGroup>
      {currentFont === CUSTOM_GOOGLE_FONT_FAMILY && (
        <div>
          <FontPicker
            apiKey={googleFontsApiKey}
            activeFontFamily={customGoogleFontFamily || DEFAULT_GOOGLE_FONT}
            limit={NUMBER_OF_GOOGLE_FONTS_TO_LOAD}
            onChange={(nextFont) => {
              updateFontOptions(nextFont.family, '');
            }}
          />
        </div>
      )}

      {currentFont === CUSTOM_FONT && (
        <FontUpload
          uploadCompletedCallback={uploadCompletedCallback}
          onCustomFontDelete={onCustomFileDeleted}
          academyId={academyId}
          customFontFile={customFontFile}
        />
      )}
    </Stack>
  );
}
